'use client';

import React, { useMemo, useState } from 'react';
import {
  DEFAULT_LOGO_URL,
  DEFAULT_PLATFORM_NAME,
  usePlatformSettings,
} from '@/contexts/PlatformSettingsContext';

interface AppLogoProps {
  className?: string;
  size?: number | string;
  src?: string;
  onClick?: () => void;
}

export default function AppLogo({ className = 'h-8 w-auto', size, src, onClick }: AppLogoProps) {
  const { logoUrl, platformName } = usePlatformSettings();
  const [error, setError] = useState(false);

  const resolvedSrc = !error ? src || logoUrl || DEFAULT_LOGO_URL : DEFAULT_LOGO_URL;
  const inlineStyle = useMemo<React.CSSProperties | undefined>(() => {
    if (size === undefined) return undefined;
    return {
      height: typeof size === 'number' ? `${size}px` : size,
      width: 'auto',
    };
  }, [size]);

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={resolvedSrc}
      alt={platformName || DEFAULT_PLATFORM_NAME}
      className={`${className} object-contain flex-shrink-0 ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`.trim()}
      style={inlineStyle}
      onClick={onClick}
      onError={() => setError(true)}
    />
  );
}
